module.exports = __webpack_public_path__ + "06_hige_white.2db48651.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/06_hige_white.png
// module id = y4Qm
// module chunks = 0